import type { SpatialRectangle } from "#public"

import { BoundingBox } from "./BoundingBox"

/** The smallest box holding every one of `boxes`: the one round their corners. */
export const Outline = <T extends number>(boxes: SpatialRectangle<T>[]): SpatialRectangle<T> =>
  BoundingBox(
    ...boxes.flatMap(({ x, y, width, height }) => [
      { x, y },
      { x: (x + width) as T, y: (y + height) as T },
    ])
  )
